import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Form from './Form';
import Confirmation from './Confirmation';
import { useQueryMutation } from '../../../hooks/@lore/query-connect';

export default function OfferDeleteDialog(props) {
  const { offer } = props;

  const [data, setData] = useState({
    confirmation: ''
  });
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('offer.update', offer);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      // props.onCancel();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate({
      published: false,
      cancelled: true,
      cancelledAt: new Date().toISOString()
    });
  }

  function onChange(name, value) {
    const nextData = _.merge({}, data);
    nextData[name] = value;
    setData(nextData);
  }

  onChange = onChange.bind(data);

  return (
    <DialogTemplate>
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          confirmation: [validators.isValue('CANCEL')]
        }}>
          {({errors, hasError}) => {
            if (success) {
              return (
                <Confirmation
                  offer={offer}
                  onCancel={props.onCancel}
                />
              );
            }

            return (
              <Form
                data={data}
                errors={errors}
                showErrors={showErrors}
                onChange={onChange}
                onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
                onCancel={props.onCancel}
                alert={error ? (
                  <RequestError request={request}/>
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : (false && success) ? (
                  <SuccessMessage>
                    Idea created.
                  </SuccessMessage>
                ) : null}
              />
            )
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
